// @core/api/endpoints/secret/sign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SignRequest,
  SignResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Sign data
 * Signs input data using the named key (ED25519, ECDSA, RSA, or HMAC). Input must be base64-encoded. Returns signature in Vault format.
 */
export async function Sign(
  engine_id: string,
  key_name: string,
  data: SignRequest,
  options?: RequestOptions
): Promise<SignResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/sign/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.post<SignResponse>(requestPath, data, requestOptions);
}
